import { gql } from '@apollo/client';

export const SURVEY = gql`
  fragment survey on Survey {
    id
    title
    description
    anonymousEnabled
    questions
    status
    createdAt
  }
`;

export const CREATE_SURVEY = gql`
  mutation CreateSurvey($input: CreateSurveyInput!) {
    createSurvey(input: $input) {
      ...survey
    }
  }
  ${SURVEY}
`;

export const PATCH_SURVEY = gql`
  mutation PatchSurvey($input: PatchSurveyInput!) {
    patchSurvey(input: $input) {
      ...survey
    }
  }
  ${SURVEY}
`;

export const PUBLISH_SURVEY = gql`
  mutation PublishSurvey($input: PublishSurveyInput!) {
    publishSurvey(input: $input) {
      ...survey
    }
  }
  ${SURVEY}
`;

export const UPDATE_SURVEY_QUESTIONS = gql`
  mutation UpdateSurveyQuestions($input: PublishSurveyInput!) {
    updateSurveyQuestions(input: $input)
  }
`;

export const CLOSE_SURVEY = gql`
  mutation CloseSurvey($id: UUID!) {
    closeSurvey(id: $id)
  }
`;

export const GET_SURVEY_BASICS_BY_ID = gql`
  query GetSurveyBasicsById($id: UUID!) {
    survey: getSurveyById(id: $id) {
      id
      title
      description
      anonymousEnabled
      pages
    }
  }
`;

export const GET_SURVEY_QUESTIONS_BY_ID = gql`
  query GetSurveyQuestionsById($id: UUID!) {
    survey: getSurveyById(id: $id) {
      id
      status
      questions
      anonymousEnabled
    }
  }
`;

export const GET_SURVEY_STATUS_BY_ID = gql`
  query GetSurveyStatusById($id: UUID!) {
    status: getSurveyStatusById(id: $id)
  }
`;

export const GET_SURVEYS = gql`
  query GetSurveys($page: Int!, $size: Int!) {
    getSurveys(page: $page, size: $size) {
      surveys {
        id
        title
        status
        pages
        createdBy
        createdAt
        responseCount
      }
      totalSize
      totalPages
      size
      page
    }
  }
`;

export const GET_SURVEY_STATISTICS = gql`
  query GetSurveyStatistics {
    getSurveyStatistics {
      totalSurveys
      activeSurveys
    }
  }
`;

export const CREATE_RESPONSE = gql`
  mutation CreateResponse($input: CreateResponseInput!) {
    createResponse(input: $input)
  }
`;

export const GET_SURVEY_BASICS_FOR_NOTIFICATION = gql`
  query GetSurveyBasicsForNotification {
    survey: getSurveyBasicsForNotification {
      id
      title
      description
      pages
    }
  }
`;

export const DOWNLOAD_SURVEY_RESPONSES = gql`
  query DownloadSurveyResponses($id: UUID!) {
    downloadSurveyResponses(surveyId: $id)
  }
`;
